import styled from 'styled-components';

// Curved line height calculation constants
const LINE_HEIGHT = 20; // height per content line
const TWO_LINES_BASE_HEIGHT = 28; // base height when 2+ lines (includes spacing offset)

const getCurvedLineHeight = (contentLines?: number): string => {
  if (contentLines && contentLines > 2) {
    return `${TWO_LINES_BASE_HEIGHT + (contentLines - 2) * LINE_HEIGHT}px`;
  }
  if (contentLines && contentLines === 2) {
    return `${TWO_LINES_BASE_HEIGHT}px`;
  }
  return `${LINE_HEIGHT}px`;
};

export const VerticalLine = styled.div<{ $hasLockCardPurse?: boolean }>`
  position: absolute;
  width: 2px;
  background: ${({ theme }) => theme.colors.border};
  left: 31px;
  top: 47.5px;
  height: 41px;
  z-index: 1;
`;

export const PayoutConnectorLine = styled.div`
  position: absolute;
  left: -18px;
  top: -13px;
  width: 32px;
  height: 44px;
  z-index: 1;
  pointer-events: none;
  border-left: 2px solid ${({ theme }) => theme.colors.border};
  border-bottom: 2px solid ${({ theme }) => theme.colors.border};
  border-bottom-left-radius: ${({ theme }) => theme.rounds.container1Round};
`;

export const CurvedLine = styled.div<{ $contentLines?: number }>`
  position: absolute;
  left: 15px;
  top: 31px;
  width: 14px;
  height: ${({ $contentLines }) => getCurvedLineHeight($contentLines)};
  z-index: 1;
  pointer-events: none;
  border-left: 2px solid ${({ theme }) => theme.colors.border};
  border-bottom: 2px solid ${({ theme }) => theme.colors.border};
  border-bottom-left-radius: ${({ theme }) => theme.rounds.container1Round};
`;

export const ConnectorVerticalLine = styled.div`
  position: absolute;
  top: -1px;
  bottom: 0;
  width: 2px;
  background: ${({ theme }) => theme.colors.border};
  pointer-events: none;
  &::before {
    content: '';
    position: absolute;
    bottom: 2px;
    left: -8.7px;
    width: 12px;
    height: 2px;
    border-radius: ${({ theme }) => theme.rounds.container1Round};
    transform: rotate(45deg);
    background: ${({ theme }) => theme.colors.border};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: -1.3px;
    width: 12px;
    height: 2px;
    border-radius: ${({ theme }) => theme.rounds.container1Round};
    transform: rotate(-45deg);
    background: ${({ theme }) => theme.colors.border};
  }
`;

export const ExpandButtonBox = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.border2};
  background: ${({ theme }) => theme.colors.canvas};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  transition: background 0.15s;

  ${({ $disabled, theme }) =>
    !$disabled &&
    `
    &:hover {
      background: ${theme.colors.border2};
    }
  `}
`;
